import { render, staticRenderFns } from "./InvitationBanner.vue?vue&type=template&id=0fa286cc&scoped=true"
import script from "./InvitationBanner.vue?vue&type=script&lang=ts"
export * from "./InvitationBanner.vue?vue&type=script&lang=ts"
import style0 from "./InvitationBanner.vue?vue&type=style&index=0&id=0fa286cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa286cc",
  null
  
)

export default component.exports